/** List Element Types
    @readonly
    @enum {string}
*/
export var LISTTYPES;
(function (LISTTYPES) {
    LISTTYPES["UL"] = "UL";
    LISTTYPES["OL"] = "OL";
    LISTTYPES["DL"] = "DL";
    LISTTYPES["MENU"] = "MENU";
})(LISTTYPES || (LISTTYPES = {}));
;
